export const myPubDetailBreadCrumb = (text: any) => {

    return [
        {
            label: "Mis publicaciones",
            to: "/perfil/mis_publicaciones"
        },
        {
            label: text,
        }
    ];
}

export const myPubManagementBreadCrumb = (id: any) => {

    return [
        {
            label: "Mis publicaciones",
            to: "/perfil/mis_publicaciones"
        },
        {
            label: `Gestión`,
            to: `/perfil/mis_publicaciones/${id}/gestion`,
            bold: true
        }
    ];
}

export const myPubEditBreadCrumb = (id: any, text: any) => {

    return [
        {
            label: "Mis publicaciones",
            to: "/perfil/mis_publicaciones"
        },
        {
            label: `Revisar - ${text}`
        }
    ];
}

export const myBuysManagementBreadCrumb = (id: any) => {

    return [
        {
            label: "Mi actividad",
            to: "/perfil/mis_compras"
        },
        {
            label: `Gestión`,
            to: `/perfil/mis_compras/${id}/gestion`,
            bold: true
        }
    ];
}

export const myBuysPaymentsBreadCrumb = (text: any) => {

    return [
        {
            label: "Mi actividad",
            to: "/perfil/mis_compras"
        },
        {
            label: `Pagos - ${text}`
        }
    ];
}

export const myBuysPaymentMethodBreadCrumb = (id: any, text: any) => {

    return [
        {
            label: "Mi actividad",
            to: "/perfil/mis_compras"
        },
        {
            label: "Pagos",
            to: "/perfil/mis_compras/" + id + "/pagos"
        },
        {
            label: `Vale vista - ${text}`
        }
    ];
}

export const myBuysQRBreadCrumb = (text: any) => {

    return [
        {
            label: "Mi actividad",
            to: "/perfil/mis_compras"
        },
        {
            label: `Generar QR - ${text}`
        }
    ];
}

export const myBuysInspectionsBreadCrumb = (text: any) => {

    return [
        {
            label: "Mi actividad",
            to: "/perfil/mis_compras"
        },
        {
            label: `Ver inspecciones - ${text}`
        }
    ];
}